export default __webpack_public_path__ + "static/media/slider5.2094d5ca.jpg";